import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import PhoneMockup from './mockups/PhoneMockup';
import { Reveal } from './motion';

const POINTS = [
  ['Today', 'Your boat, seat, crew and the piece \u2014 the first thing you see at 5:30 AM.'],
  ['Training', 'Log a session in three taps, or review what Strava already imported.'],
  ['Results', 'Submit a coach\u2019s test piece from the erg, splits and all.'],
  ['Meters', 'Attribute a row\u2019s meters to the boat and the crew before you leave the bay.'],
];

export default function MobileSection() {
  const reduce = useReducedMotion();

  return (
    <section id="mobile" className="relative overflow-hidden bg-slate-950 py-20 sm:py-28">
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[32rem] w-[32rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-600/15 blur-[100px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-6xl safe-area-x sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-400">
              In your pocket
            </p>
            <h2 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Nobody checks a spreadsheet on the dock.
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-400">
              The companion app carries the athlete workflows onto iOS and Android, with push
              notifications when a workout or test piece is published. Coaches keep the heavy
              building tools on the web, where there&rsquo;s room to work.
            </p>

            <dl className="mt-8 space-y-5">
              {POINTS.map(([term, desc], i) => (
                <Reveal key={term} delay={0.06 * i} y={16}>
                  <dt className="text-sm font-semibold text-white">{term}</dt>
                  <dd className="mt-1 text-sm leading-relaxed text-slate-400">{desc}</dd>
                </Reveal>
              ))}
            </dl>
          </Reveal>

          <Reveal delay={0.15} y={40}>
            <motion.div
              animate={reduce ? undefined : { y: [0, -12, 0] }}
              transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
            >
              <PhoneMockup />
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
